import { render, staticRenderFns } from "./payment-method-popup.vue?vue&type=template&id=ff1cbe34"
import script from "./payment-method-popup.vue?vue&type=script&lang=js"
export * from "./payment-method-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff1cbe34')) {
      api.createRecord('ff1cbe34', component.options)
    } else {
      api.reload('ff1cbe34', component.options)
    }
    module.hot.accept("./payment-method-popup.vue?vue&type=template&id=ff1cbe34", function () {
      api.rerender('ff1cbe34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/settings/payment-method-popup.vue"
export default component.exports